import React from "react";
import { Segment, Container } from "semantic-ui-react";

export class ImprintEN extends React.Component {
  state = {};

  render() {
    return (
      <Segment style={{ padding: "4em 0em", margin: 0 }}>
        <Container text>
          <div style={{ fontSize: "1.33em" }}>
            <h1>Imprint</h1>

            <h2>Information according to § 5 TMG:</h2>
            <h3>
              audory UG (haftungsbeschränkt)
              </h3>
              <p>
                Technologie-Campus 1
                <br />
                09126 Chemnitz
                <br/>
                <br/>
                Handelsregister: HRB 33582
                <br/>
                Registered at Chemnitz local court
              </p>
              <hr/>
              <h3>
              Authorized representative executive director
              </h3>
              <p>
                Max Rose<br/>
                E-Mail: max.rose@audory.io<br/>
                Telefon: +49 1577 3064495
              </p>
              <hr/>

            <h3>Liability for content</h3>
            <p>
              As a service provider we are responsible according to § 7 Abs.1
              TMG for our own contents on these pages according to the general
              laws. According to §§ 8 to 10 TMG, we are not obliged as a service
              provider to monitor transmitted or stored third-party information
              or to investigate circumstances that indicate illegal activity.
              <br />
              Obligations to remove or block the use of information in
              accordance with general laws remain unaffected by this. However,
              liability in this respect is only possible from the time of
              knowledge of a concrete violation of the law. As soon as we become
              aware of such infringements, we will remove the content
              immediately.
            </p>
            <h3>Liability for links</h3>
            <p>
              Our offer contains links to external websites of third parties on
              whose contents we have no influence. Therefore, we cannot assume
              any liability for these external contents. The respective provider
              or operator of the pages is always responsible for the contents of
              the linked pages. The linked pages were checked for possible legal
              infringements at the time of linking. Illegal contents were not
              recognizable at the time of linking.
              <br />
              However, a permanent control of the contents of the linked pages
              is not reasonable without concrete evidence of a violation of the
              law. As soon as we become aware of any legal infringements, we
              will remove such links immediately.
            </p>
            <h3>Copyright</h3>
            <p>
              The contents and works on these pages created by the site
              operators are subject to German copyright law. The duplication,
              processing, distribution and any kind of use outside the limits of
              copyright law require the written consent of the respective author
              or creator. Downloads and copies of these pages are only permitted
              for private, non-commercial use.
              <br />
              Insofar as the content on this site was not created by the
              operator, the copyrights of third parties are respected. In
              particular contents of third parties are marked as such. Should
              you nevertheless become aware of an infringement of copyright,
              please inform us accordingly. As soon as we become aware of any
              infringements, we will remove such content immediately.
            </p>
          </div>
        </Container>
      </Segment>
    );
  }
}

export default ImprintEN;



// WEBPACK FOOTER //
// ./src/components/Imprint/ImprintEN.js